
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-51028794!sass-loader?indentedSyntax&sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PendingRecordsList.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PendingRecordsList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-51028794!../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PendingRecordsList.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/backoffice/PendingRecordsList.vue
// module id = 2168
// module chunks = 1